import { createSlice } from "@reduxjs/toolkit";
import { pointerStatus } from "../constants/LivePointerConstants";

const initialState = {
    livePointerInProgress: false,
    autoLivePointerInProgress: false, // Separate flag for auto-start (doesn't disable button)
    pointerOn: false,
    pointerStCode: pointerStatus.DISABLED,
    vcanvas: null,
    livePointerColors: {},
    pointerLiveStream: false,
};
const livePointerReducerSlice = createSlice({
    name: "livePointerReducer",
    initialState,
    reducers: {
        setLivePointerInProgress(state, action) {
            state.livePointerInProgress = action.payload;
        },
        setAutoLivePointerInProgress(state, action) {
            state.autoLivePointerInProgress = action.payload;
        },
        setPointerOn(state, action) {
            state.pointerOn = action.payload;
        },
        setPointerStCode(state, action) {
            state.pointerStCode = action.payload;
        },
        setVcanvas(state, action) {
            state.vcanvas = action.payload;
        },
        setLivePointerColors(state, action) {
            state.livePointerColors = action.payload;
        },
        setPointerLiveStream(state, action) {
            state.pointerLiveStream = action.payload;
        },
        resetlivePointerReducer() {
            return initialState;
        },
    },
});

export const {
    setLivePointerInProgress,
    setAutoLivePointerInProgress,
    setPointerOn,
    setPointerStCode,
    setVcanvas,
    setLivePointerColors,
    setPointerLiveStream,
    resetlivePointerReducer,
} = livePointerReducerSlice.actions;
export default livePointerReducerSlice.reducer;
